/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaTypeItem } from '../../models/media-type-item';

export interface MediaTypeControllerRemove$Params {
  id: string;
}

export function mediaTypeControllerRemove(http: HttpClient, rootUrl: string, params: MediaTypeControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaTypeControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaTypeItem;
      }>;
    })
  );
}

mediaTypeControllerRemove.PATH = '/file-manager/types/{id}';
